import type { QuickPoll } from "@/types";
import type { ResponsePayload } from "@/types/model";
import { getData, postData, patchData } from "../base.ehq.model";
import { deserialize } from "../base.serializer";
import { serialize } from "./quick-poll.serializer";

type QuickPollAnswer = {
  optionId?: string | number | null;
};

type QuickPollResponse = {
  id?: string | number;
} & Record<string, unknown>;

export const getQuickPoll = async (
  token: string | null,
  baseUrl: string,
  projectId: string,
  quickPollId: string,
  config: object = {}
): Promise<QuickPoll> => {
  const queryPath = `${baseUrl}/projects/${projectId}/quick_polls/${quickPollId}`;

  return await getData(token, queryPath, {}, config).then(
    (response: ResponsePayload) => deserialize(response.data)
  );
};

export const setQuickPoll = async (
  token: string | null,
  baseUrl: string,
  projectId: string,
  quickPollId: string,
  body: QuickPollAnswer = {}
): Promise<QuickPollResponse> => {
  const queryPath = `${baseUrl}/projects/${projectId}/quick_polls/${quickPollId}/responses`;
  const serializedBody = serialize(body);

  return await postData(token, queryPath, {}, serializedBody).then(
    (response: ResponsePayload) => deserialize(response.data)
  );
};

export const patchQuickPoll = async (
  token: string | null,
  baseUrl: string,
  projectId: string,
  quickPollId: string,
  responseId: string | number,
  body: QuickPollAnswer = {}
): Promise<QuickPollResponse> => {
  const queryPath = `${baseUrl}/projects/${projectId}/quick_polls/${quickPollId}/responses/${responseId}`;
  const serializedBody = serialize(body);

  return await patchData(token, queryPath, {}, serializedBody).then(
    (response: ResponsePayload) => deserialize(response.data)
  );
};
